// extracted by mini-css-extract-plugin
export default {"edu":"Edu_edu__kQsWu","progressCharts":"Edu_progressCharts__iMIF+","heading":"Edu_heading__IAix+","boxes":"Edu_boxes__v9wEa","courses":"Edu_courses__lUuKs"};